export default {
  models: [],
  system: null,
  model: null,
  // тут теперь храниться id суб модели
  subModel: null,
  cameraPhoto: null,
  materials: [],
  materialsItem: null,
  modelsOptions: null,
  preselectedModel: null,
  preselectedSystem: null,
  // триггер для поповера модели, к примеру в урле есть view=2,2, значит модель предвыбрана по ссылке
  isTriggerModelPopover: false,
  isDisabledMaterials: true,
  isDisabledSizes: true,
  isDisabledOptions: true,
  // триггер для сброса данных после оформления заказа
  triggerResetData: 0,
  modelSize: {
    width: "",
    height: "",
  },
  modelColors: null,
  modelColorActive: '',
  modelView: '',
  queryParams: {
    element: {
      logo: true,
      basket: true,
      sum: true,
      header: true,
      price: true,
    },
    size: {
      width: '',
      height: '',
    },
    model: {
      type: '',
      model: '',
      sub: '',
      material: ''
    }
  },
}
